<template>
  <div class="container">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="活动配置" name="decoration"></el-tab-pane>
      <el-tab-pane label="活动数据" name="list"></el-tab-pane>
    </el-tabs>
    <decoration ref="decoration" v-show="activeName == 'decoration'" />
    <activityData ref="list" v-show="activeName == 'list'" />
  </div>
</template>
<script>
import Decoration from "./decoration";
import activityData from "./activityData";
export default {
  name: "starWallpapers",
  components: {
    Decoration,
    activityData,
  },
  data() {
    return {
      activeName: "decoration",
    };
  },
  mounted() {
    this.handleClick({ name: this.activeName });
  },
  methods: {
    handleClick({ name }) {
      if (name == "decoration") {
        this.$refs.decoration.init();
      } else if (name == "list") {
        this.$refs.list.initData();
      }
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  margin: 24px;
  padding: 24px;
  border-radius: 8px;
  background: #ffffff;
  height: 100%;
  min-width: 1046px;

  .topbox {
    margin-bottom: 24px;
    font-size: 18px;
    font-weight: bold;
    color: #000;
  }
}
</style>
